<template>
  <el-select
    v-model="selectValue"
    :disabled="disabled"
    :placeholder="placeholder"
  >
    <el-option-group
      :label="formatOptionLabel(group.groupDesc)"
      :key="groupIndex + 'group'"
      v-for="(group, groupIndex) in groups"
      v-if="!hasOneGroup"
    >
      <el-option
        v-for="(optionLabel, optionValue) in group.options"
        :key="optionValue"
        :label="formatOptionLabel(optionLabel)"
        :value="formatOptionValue(optionValue)"
      ></el-option>
    </el-option-group>
    <el-option
      v-else
      v-for="(optionLabel, optionValue) in groups[0].options"
      :key="optionValue"
      :label="formatOptionLabel(optionLabel)"
      :value="formatOptionValue(optionValue)"
    ></el-option>

    <template v-if="selectValue !== undefined" #prefix>
      <div>
        {{ labelFormatted }}
      </div>
    </template>
  </el-select>
</template>

<script>
export default {
  name: 'GroupedPrefixSelect',

  props: {
    value: {
      required: false
    },

    groups: {
      type: Array,
      required: true
    },

    placeholder: {
      type: String,
      required: false
    },

    number: {
      type: Boolean,
      default: false
    },

    translate: {
      type: Boolean,
      required: false,
      default: true
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    selectedOptionLabel() {
      let label = ''
      this.groups.forEach(item => {
        Object.keys(item.options).forEach(key => {
          let keyFormatted = key
          if (this.number) {
            keyFormatted = Number(keyFormatted)
          }
          if (this.selectValue === keyFormatted) {
            label = item.options[key]
          }
        })
      })
      return this.translate ? this.$t(label) : label
    },

    selectedOptionGroupTitle() {
      let label = ''
      this.groups.forEach(item => {
        Object.keys(item.options).forEach(key => {
          let keyFormatted = key
          if (this.number) {
            keyFormatted = Number(keyFormatted)
          }
          if (this.selectValue === keyFormatted) {
            label = item.groupTitle
          }
        })
      })
      return this.translate ? this.$t(label) : label
    },

    selectValue: {
      get() {
        let valueAvailable = false
        this.groups.forEach(item => {
          Object.keys(item.options).forEach(key => {
            let keyFormatted = key
            if (this.number) {
              keyFormatted = Number(keyFormatted)
            }
            if (this.value === keyFormatted) {
              valueAvailable = true
            }
          })
        })

        if (!valueAvailable) {
          return undefined
        }

        return this.value
      },

      set(selectValue) {
        this.$emit('input', selectValue)
      }
    },
    hasOneGroup() {
      return this.groups.length === 1
    },
    labelFormatted() {
      let label = this.selectedOptionLabel

      if (!this.hasOneGroup) {
        label += ' (' + this.selectedOptionGroupTitle + ')'
      }

      return label
    }
  },

  methods: {
    formatOptionValue(optionValue) {
      if (this.number) {
        return Number(optionValue)
      } else {
        return optionValue
      }
    },

    formatOptionLabel(optionLabel) {
      return this.translate ? this.$t(optionLabel) : optionLabel
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select-dropdown__item {
  height: max-content;
}
>>> .el-input__inner {
  color: #ffffff;
}
>>> .el-input__prefix {
  color: #606266;
  display: flex;
  align-items: center;
  padding-left: 13px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/GroupedPrefixSelect.vue